import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import FilterDropdown from "../../FilterDropdown";
import { filterConfig } from "../filterConfig";
import styles from "./index.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faSearch } from "@fortawesome/free-solid-svg-icons";

const VerticalSearchFilters = ({
  makes,
  models,
  modelCodes,
  onMakeSelect,
  onModelSelect,
  ...props
}) => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [filters, setFilters] = useState({});
  const [openSections, setOpenSections] = useState({});
  const [searchText, setSearchText] = useState("");

  // Load filters from URL
  useEffect(() => {
    const params = Object.fromEntries([...searchParams.entries()]);
    setFilters(params);

    if (params.search) {
      setSearchText(params.search);
    }
  }, [searchParams]);

  const toggleSection = (key) => {
    setOpenSections(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const updateFilter = (key, option) => {

    if (key === "make") {
      setFilters(prev => ({
        ...prev,
        make: option.name,
        model: "",
        modelCode: ""
      }));

      onMakeSelect && onMakeSelect(option.id);
      return;
    }

    if (key === "model") {
      setFilters(prev => ({
        ...prev,
        model: option.name,
        modelCode: ""
      }));

      onModelSelect && onModelSelect(option.id);
      return;
    }

    setFilters(prev => ({
      ...prev,
      [key]: option.name
    }));
  };

  const findCars = () => {

    const filtered = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v)
    );

    const params = new URLSearchParams(filtered).toString();

    navigate(`/vehicles?${params}`);
  };

  const handleSearch = () => {

    const updatedFilters = {
      ...filters,
      search: searchText
    };

    const filtered = Object.fromEntries(
      Object.entries(updatedFilters).filter(([_, v]) => v)
    );

    const params = new URLSearchParams(filtered).toString();

    navigate(`/vehicles?${params}`);
  };

  return (
    <div className={styles.filterBody}>
      <div className={styles.searchBox}>
        <input
          type="text"
          placeholder="Search vehicles..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className={styles.searchInput}
        />
        <button
          className={styles.searchBtn}
          onClick={handleSearch}
        >
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>
      <div className={styles.filterContainer}>

        {filterConfig.map((filter) => {

          let options = props[filter.optionsKey] || [];

          if (filter.key === "make") options = makes;
          if (filter.key === "model") options = models;
          if (filter.key === "modelCode") options = modelCodes;

          const isOpen = openSections[filter.key];
          const hasValue = filters[filter.key];

          return (
            <div key={filter.key} className={styles.accordionItem}>

              {/* Header */}
              <div
                className={styles.accordionHeader}
                onClick={() => toggleSection(filter.key)}
              >
                <span>{filter.label}</span>

                <FontAwesomeIcon
                  icon={isOpen ? faMinus : faPlus}
                  className={styles.icon}
                />
              </div>

              {/* Content */}
              {isOpen && (
                <div className={styles.accordionContent}>

                  {filter.type === "range" ? (
                    <>
                      <FilterDropdown
                        options={options}
                        placeholder="From"
                        value={filters[`${filter.key}From`]}
                        onSelect={(opt) =>
                          updateFilter(`${filter.key}From`, opt)
                        }
                      />
                      <div style={{ marginBottom: '5px' }}></div>
                      <FilterDropdown
                        options={options}
                        placeholder="To"
                        value={filters[`${filter.key}To`]}
                        onSelect={(opt) =>
                          updateFilter(`${filter.key}To`, opt)
                        }
                      />
                    </>
                  ) : (
                    <div className={styles.checkboxList}>

                      {options.map((opt) => {

                        const checked = filters[filter.key] === opt.name;

                        return (
                          <label key={opt.id} className={styles.checkboxItem}>
                            <input
                              type="checkbox"
                              checked={checked}
                              disabled={
                                (filter.key === "model" && !filters.make) ||
                                (filter.key === "modelCode" && !filters.model)
                              }
                              onChange={() =>
                                updateFilter(filter.key, checked ? { name: "" } : opt)
                              }
                            /> <span className={styles.customCheckbox}></span>
                            {opt.name}

                          </label>
                        );
                      })}

                    </div>
                  )}
                </div>
              )}

            </div>
          );
        })}

        <button className={styles.findBtn} onClick={findCars}>
          Find Car
        </button>

      </div>
    </div>
  );
};

export default VerticalSearchFilters;